'use strict';
var base = require('./base');
var common = require('../common');

/**
 * Prepares availability message to include 'Ships next business day' or not for embroidery & other products.
 * @param {Object} container - availability message container element
 * @param {Object} response - Product-Variation response object
 * @returns {Object} message - availabiliy message
 */
function prepareAvailabilityMessage(container, response) {
    var message = $.parseHTML(response.message);
    var embroidery = false;
    for (var i = 0; i < response.product.options.length; i++) {
        if (response.product.options[i].id === 'embroidery') {
            if (response.product.options[i].selectedValueId && response.product.options[i].selectedValueId === 'yes') {
                embroidery = true;
            } else {
                embroidery = false;
            }
        }
    }
    var availabilityMsg = $(container).data('availability-instock-msg');
    if (embroidery) {
        if (response.product.available) {
            $(message).find('p').html(availabilityMsg);
        }
    }
    return message && message !== '' ? message : '';
}

module.exports = {
    initResizeHandlers: base.initResizeHandlers,
    availability: base.availability,
    addToCart: base.addToCart,
    updateAttributesAndDetails: function () {
        /*
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');
            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);
            if (data.tabDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.tabDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }
            if (data.tabDetails) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.tabDetails);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
        */
    },
    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            if (!$('.quick-modal.show').length) {
                $.spinner().start();
            }
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.manufacturerSKU);
                response.container.find('.product-id').data('product-upc', response.data.product.id);
                response.container.find('.product-id').data('style-number', response.data.product.manufacturerSKU);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.manufacturerSKU);
                response.container.find('.product-id').data('product-upc', response.data.product.id);
                response.container.find('.product-id').data('style-number', response.data.product.manufacturerSKU);
            } else {
                $('.product-id').text(response.data.product.manufacturerSKU);
                $('.product-id').data('product-upc', response.data.product.id);
                $('.product-id').data('style-number', response.data.product.manufacturerSKU);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            var addToCart = $('button.add-to-cart', response.$productContainer);
            addToCart.attr('disabled', (!response.product.available));
            // Check if this is an eGift card product - if so, let eGiftCard.js handle it
            var isEGiftCard = response.product && response.product.isEGiftCard;
            if (isEGiftCard && response.product && response.product.available) {
                $('body').trigger('egiftcard:updateButton');
                return;
            }

            if (response.product.available) {
                addToCart.text(addToCart.data('available-msg'));
            } else {
                addToCart.text(addToCart.data('unavailable-msg'));
            }
            if (response.product.readyToOrder) {
                $('button.add-to-cart').closest('.cart-and-ipay').find('.invalidAttr').addClass('d-none');
                $('.invalid-attributes-msg').find('.invalidAttr').addClass('d-none');
                addToCart.removeClass('disabled');
            } else {
                addToCart.text(addToCart.data('selectsize-msg'));
            }
            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $('button.add-to-cart-global').attr('disabled', !enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            var $availabilityMsg = $('.availability-msg', response.$productContainer);

            // Hide content visually (preserving space) to avoid layout shift,
            // then update after a brief delay to allow attribute selection to be announced first
            $availabilityMsg.css('visibility', 'hidden');

            setTimeout(function () {
                $availabilityMsg.html(function () {
                    return prepareAvailabilityMessage($(this), response);
                });
                $availabilityMsg.css('visibility', '');
            }, 100);
            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });
                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });
                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);
                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : '');
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a.size-chart-pdp__link, .size-chart button.size-chart-pdp__link').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });
        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
        $(document).on('shown.bs.modal', '#sizeChartModal', function () {
            $('.pinup-section').addClass('position-static');
        });
        $(document).on('hidden.bs.modal', '#sizeChartModal', function () {
            $('.pinup-section').removeClass('position-static');
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    validateGiftMessage: function () {
        $(document).on('blur', '#giftMessage', function () {
            /* commented this code per PM-1512 : Allow customers to use special characters in gift message field */
            // var $giftMessage = $(this);
            // // eslint-disable-next-line no-useless-escape
            // var giftMessageRegex = new RegExp(/^[\w *;\/"%()#?.'!$,\-\n]*$/);
            // if ($giftMessage.val() && $giftMessage.val().trim() !== '' && !giftMessageRegex.test($giftMessage.val().trim())) {
            //     $('.invalid-feedback-gift-message').removeClass('d-none');
            // } else {
            //     $('.invalid-feedback-gift-message').addClass('d-none');
            // }
        });
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    initiateCarouselPDP: base.setSlickSlider,
    initiateZoom: base.loadZoom(),
    initiateLazyLoad: common.lazyLoad(),
    eGiftCard: require('./eGiftCard').init
};

$(document).ready(function () {
    module.exports.eGiftCard();
    if ($('.color-attribute.swatch-attribute').find('span.swatch-circle').length === 1 && $('.color-attribute.swatch-attribute').find('span.swatch-circle').hasClass('selected') === false) {
        $('.color-attribute.swatch-attribute').find('span.swatch-circle').click();
    }
    $(document).on('afterChange', '.pdp-main-carousel', function () {
        if ($(this).find('.slick-list').find('.slick-active').find('.carousel-item')
            .hasClass('pdp-video')) {
            $('.js_mobile-zoom-icon').addClass('d-none');
        } else {
            $('.js_mobile-zoom-icon').removeClass('d-none');
        }
    });
});

$(window).scroll(function () {
    $('.fixed-add-cart-button.sticky .add-to-cart').on('click', function () {
        var variantOffset = $('.product-detail .product-attribute').offset().top;
        var headerHeight = $('header').outerHeight();

        $('html, body').scrollTop(variantOffset - headerHeight);
    });
});

// Appended logic for Shop The Look
$(document).ready(function () {
    var shopTheLook = require('./shopTheLook');
    shopTheLook.init();

    $('body').on('product:afterAttributeSelect', function (e, response) {
        var $wrapper = $('.shop-the-look-wrapper');
        if (!$wrapper.length) return;

        // 1. Do not update STL if the interaction happened inside a Quick Shop / modal
        if (response.container && (response.container.closest('.quick-view-dialog').length > 0 || response.container.closest('.modal').length > 0 || response.container.hasClass('product-quickview'))) {
            return;
        }

        var basePID = response.data.product.id;
        var color = null;
        if (response.data.product && response.data.product.variationAttributes && response.data.product.variationAttributes.length) {
            response.data.product.variationAttributes.forEach(function (attribute) {
                if (attribute.id === 'color' && attribute.values && attribute.values.length) {
                    attribute.values.forEach(function (attrVal) {
                        if (attrVal.selected) {
                            color = attrVal.id;
                        }
                    });
                }
            });
        }

        if (!color) return;

        // 2. Only update if the color actually changed
        var lastColor = $wrapper.attr('data-current-color');

        // If it's the exact same color, do nothing (e.g. user selected a size)
        if (lastColor === color) {
            return;
        }

        // Update the tracked color
        $wrapper.attr('data-current-color', color);

        // The URL pattern
        var stlUrl = $wrapper.data('stl-url');
        if (stlUrl && basePID) {
            // Update the URL with new Variant ID (color change handles PID update)
            var updateUrl = stlUrl.split('?')[0] + '?pid=' + basePID;
            if (color) {
                updateUrl += '&colorCode=' + color;
            }
            shopTheLook.update(updateUrl);
        }
    });

    // Initialize current color on page load
    $(document).ready(function () {
        var $wrapper = $('.shop-the-look-wrapper');
        if ($wrapper.length) {
            var initialColor = $('.product-detail[data-pid]').first().find('[data-attr="color"] .selected').data('attr-value')
                            || $('.product-detail[data-pid]').first().find('[data-attr="color"] option:selected').val();
            if (initialColor) {
                $wrapper.attr('data-current-color', initialColor);
            }
        }
    });
});
